export const enum ConfigKeys {
  PasswordPolicy = 'password-policy',
  DateTimeFormat = 'date-time format',
  WorkingTimings = 'working-timing',
  CancerTypes = 'cancer-types',
  Comorbidities = 'co-morbidities',
  FoodCategories = 'food-categories',
  FoodServingUnits = 'food-serving-units',
  FoodBenefits = 'food-benefits',
  Profile = 'profile',
  AlertConfigs = 'alert-configs',
  VcModuleConfig = 'vc-module-config',
  IsVcActive = 'is_active',
  Relations = "relations",
  DroppingReasons = "drop-reasons",
  LeadOptOutReasons = "lead-opt-out-reasons"
}
